export default "__VITE_ASSET__CQRXDX8r__"